export default "__VITE_ASSET__2uHKXLtq__"